import { createApp } from 'vue'
import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';


import './assets/js/flexible.js';
import './global.css';

import Clipboard from 'v-clipboard'




import router from './router'

const app = createApp(App)
// app.config.globalProperties.domain = 'http://localhost:5500/';
app.config.globalProperties.domain = 'https://ai.mingxiaolu.cn/';
app.config.globalProperties.signDomain='https://qr.liangks.com/';
// app.config.globalProperties.signDomain='http://localhost:5000/'

app.use(Clipboard)

app.use(router)
app.mount('#app')


